"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TreeSelect = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactBootstrap = require("react-bootstrap");

var _treeSelectUtils = require("./tree-select-utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var TreeSelect = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onChange = _ref.onChange,
      tree = _ref.data,
      value = _ref.value,
      singleSelect = _ref.singleSelect,
      style = _ref.style;
  var data = {
    tree: tree,
    categories: tree,
    flat: (0, _treeSelectUtils.flattenTree)(tree)
  };
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      resetSearchFilter: function resetSearchFilter() {
        clearSearchFilter();
        collapseAllParents();
      },
      expandSelectedvalue: function expandSelectedvalue(displayTreeParent) {
        collapseAllParents();
        expandParents(displayTreeParent);
      }
    };
  }); // check parent checked/indeterminate state when tree is loaded/reloaded

  (0, _react.useEffect)(function () {
    if (!data || !value || value.length < 1) return;
    var parents = [];

    if (singleSelect) {
      parents = getParents(value);
    } else {
      value.forEach(function (val) {
        return parents.push(getParents(val));
      });
      parents = parents.flat();
    }

    parents.map(function (parent) {
      return checkParents(parent);
    });

    if (singleSelect) {
      expandParents({
        data: value
      });
    } else {
      value.forEach(function (val) {
        return expandParents({
          data: val
        });
      });
    }
  }, [data]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      expandAll = _useState2[0],
      setExpandAll = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = _slicedToArray(_useState3, 2),
      searchInput = _useState4[0],
      setSearchInput = _useState4[1];

  var _useState5 = (0, _react.useState)('categorical'),
      _useState6 = _slicedToArray(_useState5, 2),
      listType = _useState6[0],
      setListType = _useState6[1]; // clear any search input text, set tree select to categorical/tree view


  var clearSearchFilter = function clearSearchFilter() {
    setSearchInput('');
    setListType('categorical');
  }; // given child, expand all parent tree nodes leading to child in tree


  var expandParents = function expandParents(displayTreeParent) {
    var parents = getParents(displayTreeParent.data);
    parents.push(displayTreeParent.data);
    parents.map(function (item) {
      if (document.getElementsByClassName('collapse-button-text-' + item.id)[0]) {
        if (document.getElementsByClassName('collapse-button-text-' + item.id)[0].classList.contains("fa-plus-square")) {
          document.getElementsByClassName('collapse-button-text-' + item.id)[0].click();
        }
      }
    });
  }; // find all parents of a node


  var getParents = function getParents(node) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    data && data.categories.map(function (item) {
      item.children.map(function (child) {
        if (child.title === node.title && child.id === node.id) {
          parents.push(item);
          getParents(item, parents);
        }
      });
    });
    return parents;
  }; // helper func to find all leafs of a node


  var getLeafs = function getLeafs(item, node) {
    var allLeafs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    if (!node.children || node.children.length === 0) {
      allLeafs.push(node);
    } else {
      if (document.getElementsByClassName('parent-checkbox-' + node.id)[0]) {
        document.getElementsByClassName('parent-checkbox-' + node.id)[0].checked = true;
      }

      for (var i = 0; i < node.children.length; i++) {
        allLeafs = getLeafs(item, node.children[i], allLeafs);
      }
    }

    return allLeafs;
  }; // find all leafs of a node


  var getAllLeafs = function getAllLeafs(item) {
    var allLeafs = [];

    if (item.children && item.children.length > 0) {
      // check if item is parent
      for (var i = 0; i < item.children.length; i++) {
        var child = item.children[i];
        allLeafs = allLeafs.concat(getLeafs(item, child));
      }
    } else {
      // if (!item.parent) {
      // check if item is not parent
      allLeafs.push(item); // }
    }

    return allLeafs;
  }; // expand all parent nodes in tree


  var toggleExpandAllParents = function toggleExpandAllParents() {
    if (!expandAll) {
      for (var i = 0; i < data.categories.length; i++) {
        var className = 'children-of-' + data.categories[i].id;

        if (document.getElementsByClassName(className)[0].style.display && document.getElementsByClassName(className)[0].style.display === 'none') {
          document.getElementsByClassName(className)[0].style.display = 'block';
          var collapseButton = document.getElementsByClassName('collapse-button-text-' + data.categories[i].id)[0];
          collapseButton.classList.toggle('fa-plus-square', false);
          collapseButton.classList.toggle('fa-minus-square', true);
        }
      }

      setExpandAll(true);
    } else {
      for (var _i2 = 0; _i2 < data.categories.length; _i2++) {
        var _className = 'children-of-' + data.categories[_i2].id;

        if (document.getElementsByClassName(_className)[0].style.display && document.getElementsByClassName(_className)[0].style.display === 'block') {
          document.getElementsByClassName(_className)[0].style.display = 'none';
          var _collapseButton = document.getElementsByClassName('collapse-button-text-' + data.categories[_i2].id)[0];

          _collapseButton.classList.toggle('fa-plus-square', true);

          _collapseButton.classList.toggle('fa-minus-square', false);
        }
      }

      setExpandAll(false);
    }
  }; // collapse all parent nodes in tree


  var collapseAllParents = function collapseAllParents() {
    if (!data) return;

    for (var i = 0; i < data.categories.length; i++) {
      var className = 'children-of-' + data.categories[i].id;

      if (document.getElementsByClassName(className)[0].style.display && document.getElementsByClassName(className)[0].style.display === 'block') {
        document.getElementsByClassName(className)[0].style.display = 'none';
        var collapseButton = document.getElementsByClassName('collapse-button-text-' + data.categories[i].id)[0];
        collapseButton.classList.toggle('fa-plus-square', true);
        collapseButton.classList.toggle('fa-minus-square', false);
      }
    }

    setExpandAll(false);
  }; // hide children of specified node in tree


  var toggleHideChildren = function toggleHideChildren(name) {
    var className = 'children-of-' + name;
    var node = document.getElementsByClassName(className)[0];
    if (!node) return true;

    if (document.getElementsByClassName(className)[0].style.display && document.getElementsByClassName(className)[0].style.display === 'none') {
      document.getElementsByClassName(className)[0].style.display = 'block';
      var collapseButton = document.getElementsByClassName('collapse-button-text-' + name)[0];
      collapseButton.classList.toggle('fa-plus-square', false);
      collapseButton.classList.toggle('fa-minus-square', true);
    } else {
      document.getElementsByClassName(className)[0].style.display = 'none'; // return true;

      var _collapseButton2 = document.getElementsByClassName('collapse-button-text-' + name)[0];

      _collapseButton2.classList.toggle('fa-plus-square', true);

      _collapseButton2.classList.toggle('fa-minus-square', false);
    }
  }; // return true only if all children of a parent node is selected in tree


  var checkAllChildrenLeafsSelected = function checkAllChildrenLeafsSelected(leafs, selectedValues) {
    for (var i = 0; i < leafs.length; i++) {
      if (selectedValues.indexOf(leafs[i]) === -1) return false;
    }

    return true;
  }; // return true if at least 1 child of a parent node is selected in tree 


  var checkSomeChildrenLeafsSelected = function checkSomeChildrenLeafsSelected(leafs, selectedValues) {
    return leafs.some(function (r) {
      return selectedValues.indexOf(r) >= 0;
    });
  }; // given parent, determine its checkbox state in tree


  var checkParents = function checkParents(item) {
    if (!item) return false;
    var itemAllLeafs = getAllLeafs(item);

    if (!singleSelect) {
      // multi-select
      var checkAllLeafsSelectedResult = checkAllChildrenLeafsSelected(itemAllLeafs.map(function (obj) {
        return obj.id;
      }), value.map(function (obj) {
        return obj.id;
      }));

      if (checkAllLeafsSelectedResult) {
        var checkbox = document.getElementsByClassName('parent-checkbox-' + item.id)[0];

        if (checkbox) {
          // checkbox.checked = true;
          checkbox.indeterminate = false;
        }

        return true;
      } else {
        var checkSomeLeafsSelectedResult = checkSomeChildrenLeafsSelected(itemAllLeafs.map(function (obj) {
          return obj.id;
        }), value.map(function (obj) {
          return obj.id;
        }));

        if (checkSomeLeafsSelectedResult) {
          // show indeterminate checkbox if some (at least one) leaf is selected
          var _checkbox = document.getElementsByClassName('parent-checkbox-' + item.id)[0];

          if (_checkbox) {
            // checkbox.checked = false;
            _checkbox.indeterminate = true;
          }

          return false;
        } else {
          var _checkbox2 = document.getElementsByClassName('parent-checkbox-' + item.id)[0];

          if (_checkbox2) {
            // checkbox.checked = false;
            _checkbox2.indeterminate = false;
          }

          return false;
        } // return false;

      }
    } else {
      // single-select
      if (itemAllLeafs && value) {
        var _checkSomeLeafsSelectedResult = checkSomeChildrenLeafsSelected(itemAllLeafs.map(function (obj) {
          return obj.id;
        }), [value].map(function (obj) {
          return obj.id;
        }));

        if (_checkSomeLeafsSelectedResult) {
          // show indeterminate checkbox if some (at least one) leaf is selected
          var _checkbox3 = document.getElementsByClassName('parent-checkbox-' + item.id)[0];

          if (_checkbox3) {
            // checkbox.checked = false;
            _checkbox3.indeterminate = true;
          }

          return false;
        } else {
          var _checkbox4 = document.getElementsByClassName('parent-checkbox-' + item.id)[0];

          if (_checkbox4) {
            // checkbox.checked = false;
            _checkbox4.indeterminate = false;
          }

          return false;
        } // return false;

      } else {
        var _checkbox5 = document.getElementsByClassName('parent-checkbox-' + item.id)[0];

        if (_checkbox5) {
          // checkbox.checked = false;
          _checkbox5.indeterminate = false;
        }

        return false;
      }
    }
  }; // handle checkbox behaviors for single and multi-select tree


  var handleSelect = function handleSelect(item) {
    if (singleSelect) {
      // if single select
      onChange([item]);
    } else {
      // if multi-select
      var parentCheckboxClassName = 'parent-checkbox-' + item.id;

      var values = _toConsumableArray(value);

      var newValues = getAllLeafs(item);

      if ((0, _treeSelectUtils.containsAllVals)(values, newValues)) {
        // remove all leafs if parent is clicked and all leafs were already selected
        values = (0, _treeSelectUtils.removeAllVals)(values, newValues);

        if (document.getElementsByClassName(parentCheckboxClassName)[0]) {
          // console.log(document.getElementsByClassName(parentCheckboxClassName));
          document.getElementsByClassName(parentCheckboxClassName)[0].checked = false;
        }

        for (var i = 0; i < newValues.length; i++) {
          if (document.getElementsByClassName('leaf-checkbox-' + newValues[i].id)[0]) {
            document.getElementsByClassName('leaf-checkbox-' + newValues[i].id)[0].checked = false;
          }
        }
      } else {
        if (document.getElementsByClassName('children-of-' + item.id) && document.getElementsByClassName('children-of-' + item.id)[0] && document.getElementsByClassName('children-of-' + item.id)[0].style.display && document.getElementsByClassName('children-of-' + item.id)[0].style.display === 'none') {
          toggleHideChildren(item.id);
        }

        for (var _i3 = 0; _i3 < newValues.length; _i3++) {
          if (!(0, _treeSelectUtils.containsVal)(values, newValues[_i3].id)) {
            // only add if value did not exist before
            values.push(newValues[_i3]);

            if (document.getElementsByClassName(parentCheckboxClassName)[0]) {
              // console.log(document.getElementsByClassName(parentCheckboxClassName));
              document.getElementsByClassName(parentCheckboxClassName)[0].checked = true;
            }

            if (document.getElementsByClassName('leaf-checkbox-' + newValues[_i3].id)[0]) {
              document.getElementsByClassName('leaf-checkbox-' + newValues[_i3].id)[0].checked = true;
            }
          } else {
            // remove if new selected leaf was already selected
            if (newValues.length === 1) {
              values = (0, _treeSelectUtils.removeVal)(values, newValues[_i3].id);
            }
          }
        }
      }

      onChange(values);
    }
  }; // construct tree


  var selectTreeCategorical = function selectTreeCategorical(data) {
    return data.map(function (item) {
      if (item.children && item.children.length > 0) {
        return (
          /*#__PURE__*/
          // PARENT
          _react.default.createElement("li", {
            className: "my-1",
            style: {
              display: 'block'
            }
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "d-flex align-items-center"
          }, /*#__PURE__*/_react.default.createElement("button", {
            title: "Show/hide " + item.title + " values",
            style: {
              all: 'unset'
            },
            className: "collapse-button text-secondary",
            onClick: function onClick(e) {
              return toggleHideChildren(item.id);
            }
          }, /*#__PURE__*/_react.default.createElement("i", {
            className: "fa fa-plus-square collapse-button-text-" + item.id
          })), /*#__PURE__*/_react.default.createElement("div", {
            className: "mx-1",
            style: {
              display: 'inline-block',
              borderLeft: '1px solid white',
              height: '10px'
            }
          }), /*#__PURE__*/_react.default.createElement("input", {
            title: singleSelect ? 'Unable to select all ' + item.title + ' values\nOnly one value can be selected' : 'Select/deselect all ' + item.title + ' values',
            style: {
              verticalAlign: 'middle',
              alignSelf: 'center',
              cursor: singleSelect ? 'not-allowed' : 'pointer'
            },
            className: 'parent-checkbox-' + item.id // name={'parent-checkbox-' + item.id}
            ,
            type: "checkbox",
            "aria-label": "Checkbox" // checked={ !singleSelect && value && value.length > 0 && containsAllVals(getAllLeafs(item), value)}
            ,
            checked: checkParents(item),
            onChange: function onChange(e) {
              return handleSelect(item);
            },
            disabled: singleSelect ? true : false
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "ml-1",
            style: {
              display: 'inline-block',
              borderLeft: '1px solid white',
              height: '10px'
            }
          }), /*#__PURE__*/_react.default.createElement("button", {
            title: singleSelect ? "Show/hide " + item.title + " values" : 'Select/deselect all ' + item.title + ' values',
            className: "ml-1",
            style: {
              all: 'unset',
              cursor: 'pointer',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden'
            },
            onClick: function onClick(e) {
              return singleSelect ? toggleHideChildren(item.id) : handleSelect(item);
            }
          }, item.title)), /*#__PURE__*/_react.default.createElement("ul", {
            className: 'ml-3 pl-1 children-of-' + item.id,
            style: {
              listStyleType: 'none',
              display: 'none'
            }
          }, selectTreeCategorical(item.children)))
        );
      } else {
        return (
          /*#__PURE__*/
          // LEAF
          _react.default.createElement("li", {
            key: 'categorical-leaf-' + item.id,
            style: {
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden'
            }
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "ml-3",
            style: {
              display: 'inline-block',
              borderLeft: '1px solid white',
              height: '10px'
            }
          }), /*#__PURE__*/_react.default.createElement("input", {
            title: singleSelect ? "Select " + item.title + " value" : "Select/deselect " + item.title + " value",
            style: {
              cursor: 'pointer'
            },
            className: 'ml-1 leaf-checkbox-' + item.id // name={'leaf-checkbox-' + item.id}
            ,
            type: "checkbox",
            "aria-label": "Checkbox" // type={singleSelect ? 'radio' : 'checkbox'}
            ,
            checked: singleSelect && value && value.id === item.id || !singleSelect && value.map(function (item) {
              return item.id;
            }).includes(item.id),
            onChange: function onChange(e) {
              return handleSelect(item);
            }
          }), /*#__PURE__*/_react.default.createElement("div", {
            className: "ml-1",
            style: {
              display: 'inline-block',
              borderLeft: '1px solid white',
              height: '10px'
            }
          }), /*#__PURE__*/_react.default.createElement("button", {
            title: item.title,
            className: "ml-1",
            style: {
              all: 'unset',
              cursor: 'pointer',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              width: '65%'
            },
            onClick: function onClick(e) {
              return handleSelect(item);
            }
          }, item.title))
        );
      }
    });
  }; // construct flat list of values (only show for search filter)


  var selectTreeAlphabetical = function selectTreeAlphabetical() {
    var stringMatch = function stringMatch(item) {
      // console.log("searchInput", searchInput);
      var re1 = new RegExp(/[()~`!#$%\^&*+=\[\]\\;,/{}|\\":<>\?]/, 'gi');

      if (!re1.test(searchInput)) {
        var re2 = new RegExp(searchInput, 'gi');
        return item.title.match(re2);
      }
    };

    var dataAlphabeticalFiltered = data.flat.filter(stringMatch);

    if (dataAlphabeticalFiltered && dataAlphabeticalFiltered.length > 0) {
      return dataAlphabeticalFiltered.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: 'alpha-' + item.id,
          className: "my-1",
          style: {
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden'
          }
        }, /*#__PURE__*/_react.default.createElement("input", {
          title: "Select " + item.title + " value",
          style: {
            cursor: 'pointer'
          },
          className: 'ml-0 leaf-checkbox-' + item.id // name={'leaf-checkbox-' + item.id}
          ,
          type: "checkbox",
          "aria-label": "Checkbox",
          checked: singleSelect && value && value.id === item.id || !singleSelect && value.map(function (item) {
            return item.id;
          }).includes(item.id),
          onChange: function onChange(e) {
            return handleSelect(item);
          }
        }), /*#__PURE__*/_react.default.createElement("button", {
          title: item.title,
          className: "ml-2",
          style: {
            all: 'unset',
            cursor: 'pointer',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            width: '90%'
          },
          onClick: function onClick(e) {
            return handleSelect(item);
          }
        }, item.title.slice(0, item.title.toLowerCase().indexOf(searchInput.toLowerCase())), /*#__PURE__*/_react.default.createElement("b", null, item.title.slice(item.title.toLowerCase().indexOf(searchInput.toLowerCase()), item.title.toLowerCase().indexOf(searchInput.toLowerCase()) + searchInput.length)), item.title.slice(item.title.toLowerCase().indexOf(searchInput.toLowerCase()) + searchInput.length, item.title.length)));
      });
    } else {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "p-2"
      }, "No values found.");
    }
  }; // select all values when checkbox is toggled


  var selectAll = function selectAll() {
    if (!data) return;

    if (checkAllLeafsSelected()) {
      onChange([]);
    } else {
      var allLeafs = [];
      data.tree.map(function (item) {
        return allLeafs.push(getAllLeafs(item));
      });
      onChange(allLeafs.flat());
    }
  }; // return true if all leafs are selected


  var checkAllLeafsSelected = function checkAllLeafsSelected() {
    if (!data) return;
    var allLeafs = [];
    data.tree.map(function (item) {
      return allLeafs.push(getAllLeafs(item));
    });
    allLeafs = allLeafs.flat().map(function (item) {
      return item.id;
    });

    for (var i = 0; i < allLeafs.length; i++) {
      if (value.map(function (item) {
        return item.id;
      }).indexOf(allLeafs[i]) === -1) return false;
    }

    return true;
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "border",
    style: _objectSpread({
      // textOverflow: 'ellipsis',
      // overflowY: 'auto',
      // overflowX: 'hidden',
      // whiteSpace: 'nowrap',
      // maxHeight: '250px',
      borderColor: '#dee2e6',
      fontSize: '10pt'
    }, style)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bg-light border-bottom d-flex align-items-center py-1"
  }, listType === 'categorical' && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("button", {
    title: expandAll ? "Hide all values" : "Show all values",
    style: {
      all: 'unset'
    },
    className: "ml-1 collapse-button-all text-secondary",
    onClick: function onClick(e) {
      return toggleExpandAllParents();
    },
    disabled: !data
  }, expandAll && /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-minus-square",
    style: {
      cursor: !data ? 'not-allowed' : 'pointer'
    }
  }), !expandAll && /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-plus-square",
    style: {
      cursor: !data ? 'not-allowed' : 'pointer'
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mx-1",
    style: {
      display: 'inline-block',
      borderLeft: '1px solid #c7cbcf',
      height: '25px'
    }
  })), /*#__PURE__*/_react.default.createElement("input", {
    title: singleSelect ? 'Only one value can be selected' : 'Select/deselect all',
    style: {
      cursor: singleSelect || !data ? 'not-allowed' : 'pointer'
    },
    className: listType === 'alphabetical' ? 'ml-1' : '' // name=""
    ,
    type: "checkbox",
    "aria-label": "Checkbox",
    disabled: singleSelect || !data ? true : false,
    checked: !singleSelect && checkAllLeafsSelected(),
    onChange: function onChange(e) {
      return !singleSelect && selectAll();
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "ml-1",
    style: {
      display: 'inline-block',
      borderLeft: '1px solid #c7cbcf',
      height: '25px'
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "px-2 input-group",
    style: {
      width: '100%'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    className: "form-control py-1 h-100 border-right-0",
    style: {
      display: 'block'
    },
    title: "Search value",
    placeholder: "Search value",
    "aria-label": "Search value",
    value: searchInput,
    onChange: function onChange(e) {
      setSearchInput(e.target.value);

      if (e.target.value && e.target.value.length > 0) {
        setListType('alphabetical');
      } else {
        setListType('categorical');
      }
    },
    type: "text",
    disabled: !data
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "input-group-append"
  }, searchInput.length > 0 ? /*#__PURE__*/_react.default.createElement("button", {
    className: "input-group-text bg-white",
    title: "Clear to go back to categorical view",
    onClick: function onClick(e) {
      clearSearchFilter();
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-times",
    style: {
      fontSize: '14px'
    }
  })) : /*#__PURE__*/_react.default.createElement("button", {
    className: "input-group-text bg-white",
    title: "Filter tree input icon",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "fa fa-search",
    style: {
      fontSize: '14px'
    }
  }))))), !data && /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center justify-content-center",
    style: {
      // display: !data ? 'block' : 'none',
      minHeight: '250px',
      maxHeight: '500px'
    }
  }, !data && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Spinner, {
    animation: "border",
    variant: "primary",
    role: "status"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "sr-only"
  }, "Loading..."))), data && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("ul", {
    className: "pl-0 ml-1 mr-0 my-0",
    style: {
      display: data && listType === 'categorical' ? 'block' : 'none',
      listStyleType: 'none',
      textOverflow: 'ellipsis',
      overflowY: 'auto',
      overflowX: 'hidden',
      whiteSpace: 'nowrap',
      minHeight: '250px',
      maxHeight: '500px',
      fontSize: '10pt'
    }
  }, selectTreeCategorical(data.tree)), /*#__PURE__*/_react.default.createElement("ul", {
    className: "pl-0 ml-1 mr-0 my-0",
    style: {
      display: data && listType === 'alphabetical' ? 'block' : 'none',
      listStyleType: 'none',
      textOverflow: 'ellipsis',
      overflowY: 'auto',
      overflowX: 'hidden',
      whiteSpace: 'nowrap',
      minHeight: '250px',
      maxHeight: '500px',
      fontSize: '10pt'
    }
  }, selectTreeAlphabetical()))));
});
exports.TreeSelect = TreeSelect;